const ADMIN_RIG_DIAGNOSTICS_KEY = 'jester_admin_rig_diagnostics';

function readAdminRigQueryFlag(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search || '');
    const raw = String(params.get('adminrig') || params.get('adminRig') || '').trim().toLowerCase();
    return raw === '1' || raw === 'true' || raw === 'yes' || raw === 'on';
  } catch {
    return false;
  }
}

export function setAdminRigDiagnosticsEnabled(enabled: boolean): void {
  try {
    if (enabled) {
      sessionStorage.setItem(ADMIN_RIG_DIAGNOSTICS_KEY, '1');
    } else {
      sessionStorage.removeItem(ADMIN_RIG_DIAGNOSTICS_KEY);
    }
  } catch {}
}

export function isAdminRigDiagnosticsEnabled(): boolean {
  if (readAdminRigQueryFlag()) return true;
  try {
    return sessionStorage.getItem(ADMIN_RIG_DIAGNOSTICS_KEY) === '1';
  } catch {
    return false;
  }
}

function isNoisyTelegramWebViewMessage(args: unknown[]): boolean {
  const text = args.map((arg) => {
    if (typeof arg === 'string') return arg;
    try {
      return JSON.stringify(arg);
    } catch {
      return String(arg);
    }
  }).join(' ');

  return text.includes('[Telegram.WebView]')
    && text.includes('postEvent')
    && text.includes('web_app_request_content_safe_area');
}

export function installMiniAppConsoleNoiseFilter(): void {
  try {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.__jesterMiniAppConsoleNoiseFilterInstalled) return;
    w.__jesterMiniAppConsoleNoiseFilterInstalled = true;

    (['log', 'info', 'debug', 'warn', 'error'] as const).forEach((level) => {
      const original = console[level]?.bind(console);
      if (!original) return;
      console[level] = ((...args: unknown[]) => {
        if (!isAdminRigDiagnosticsEnabled() && isNoisyTelegramWebViewMessage(args)) return;
        original(...args);
      }) as typeof console[typeof level];
    });
  } catch {}
}
